<script>
import IconFactory from "@js/components/Icons/IconFactory.vue";
import IconDeliveryCar from "@js/components/Icons/IconDeliveryCar.vue";
import IconStar from "@js/components/Icons/IconStar.vue";
import IconCertificate from "@js/components/Icons/IconCertificate.vue";
import IconBox from "@js/components/Icons/IconBox.vue";
import IconCircleShare from "@js/components/Icons/IconCircleShare.vue";

export default {
    name: "CompanyAdvantages",
    components: {IconCircleShare, IconBox, IconCertificate, IconStar, IconDeliveryCar, IconFactory}
}
</script>

<template>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-10 mb-8">

        <!-- Честные цены -->
        <div class="flex items-center gap-5 text-sm">
            <IconStar class="min-w-[35px] max-h-[35px] min-h-[35px] max-w-[35px]"/>
            <div>
                <p class="font-bold">
                    Честные цены за лом
                </p>
                <p class="text-gray-500 text-xs font-medium">
                    Актуальные рыночные расценки. Прозрачный расчёт веса и стоимости без скрытых удержаний.
                </p>
            </div>
        </div>

        <!-- Быстрый вывоз -->
        <div class="flex items-center gap-5 text-sm">
            <IconDeliveryCar class="min-w-[35px] max-h-[35px] min-h-[35px] max-w-[35px]"/>
            <div>
                <p class="font-bold">
                    Вывоз металлолома
                </p>
                <p class="text-gray-500 text-xs font-medium">
                    Организуем выезд транспорта и погрузку. Работаем с частными лицами и предприятиями.
                </p>
            </div>
        </div>

        <!-- Точное взвешивание -->
        <div class="flex items-center gap-5 text-sm">
            <IconBox class="min-w-[35px] max-h-[35px] min-h-[35px] max-w-[35px]"/>
            <div>
                <p class="font-bold">
                    Точное взвешивание
                </p>
                <p class="text-gray-500 text-xs font-medium">
                    Современные поверенные весы. Клиент присутствует при взвешивании.
                </p>
            </div>
        </div>

        <!-- Лицензия и документы -->
        <div class="flex items-center gap-5 text-sm">
            <IconCertificate class="min-w-[35px] max-h-[35px] min-h-[35px] max-w-[35px]"/>
            <div>
                <p class="font-bold">
                    Лицензия и документы
                </p>
                <p class="text-gray-500 text-xs font-medium">
                    Работаем официально. Предоставляем все необходимые документы для юридических лиц.
                </p>
            </div>
        </div>

    </div>
</template>

<style scoped lang="scss">
</style>
